import { Injectable } from '@angular/core'
import { MbProductTabExtendedValidationAdapter } from './mb-product-tab-extended-validation.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductTabExtendedValidationConnector {

  constructor (protected adapter: MbProductTabExtendedValidationAdapter) {
  }

  get (productCode: string) {
    return this.adapter.load(productCode)
  }
}
